// extracted by mini-css-extract-plugin
export default {"Box":"OverviewHeader-module__Box--fFKf5","PublishBanners":"OverviewHeader-module__PublishBanners--QtLjz"};